
export default class FilterUtil {
    constructor(filter) {
        this.filter = filter;
    }

    filterSet(filterName) {
        return this.filter[filterName] != null &&
            this.filter[filterName].length > 0;
    }

    rangeFilterSet(results, compareTo, filterName, range) {
        let value = _.chain(this.filter).get(filterName).get(range).value();
        return value != null && results && value !== compareTo[filterName][range];
    }

    bitFilterSet(filterName) {
        return this.filter[filterName] !== false;
    }

    resetRangeFilter(results, resetFrom, filterName, range) {
        if (this.filter[filterName] !== null && results !== null) {
            this.filter[filterName] = copyRange(this.filter[filterName]);
            if (!(range instanceof Array)) {
                range = [range];
            }
            range.forEach(function(r) {
                this.filter[filterName][r] = _.chain(resetFrom)
                    .get(filterName)
                    .get(r, null)
                    .value();
            }, this);
            let isAllNull = _.every(this.filter[filterName], x => x == null);
            if (isAllNull) {
                this.filter[filterName] = null;
            }
        }
    }

    removeArrayFilter(filterName, item) {
        if (this.filter[filterName] != null) {
            const index = this.filter[filterName].indexOf(item);
            if (index >= 0) {
                this.filter[filterName].splice(index, 1);
            }
        }
    }

    removeFiltersIn(filterName, vals) {
        if (this.filter[filterName] != null) {
            this.filter[filterName] = this.filter[filterName].filter(function(v) {
                return vals.indexOf(v) < 0;
            });
        }
    }

    resetArrayFilter(filterName) {
        if (this.filter[filterName] != null) {
            this.filter[filterName].splice(0, this.filter[filterName].length);
        }
    }

    resetBooleanFilter(filterName) {
        this.filter[filterName] = false;
    }

    removeFilter(filterName) {
        this.filter[filterName] = null;
    }

    resetBitFilter(filterName) {
        this.filter[filterName] = false;
    }

    copyFilterFrom(filterName, copyFrom) {
        if (!this.filter[filterName] && copyFrom[filterName] != null) {
            this.filter[filterName] = copyRange(copyFrom[filterName]);
        }
    }

    setToNullIfMatches(filter, filterName, compareTo) {
        if (rangesMatch(filter[filterName], compareTo[filterName])) {
            filter[filterName] = null;
        }
    }

    getFilter() {
        return this.filter;
    }
}

function copyRange(r) {
    return { Min: r.Min, Max: r.Max };
}

function rangesMatch(r1, r2) {
    if (r1 && r2) {
        return (r1 === null && r2 === null) ||
        (r1 !== null && r2 !== null && r1.Min === r2.Min && r1.Max === r2.Max);
    }
}
